import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import Amplitude from '../utils/amplitudeHelper'
import PageWithBg from '../components/PageWithBg'
import LoadIcon from '../components/LoadIcon'
import { useDispatch } from 'react-redux'
import { muteMusic, unmuteMusic } from '../ducks/layout'
import config from '../config'
import { COLORS, SIZES } from '../styles/theme'
import attendance from '../images/icons/task.png'
import ChatSection from '../components/ChatSection'
import SideAgenda from '../components/SideAgenda'
import mcLogo from '../images/backdrops/MC20_logo.png'
import { ChatKfairDb } from '../firebaseConfig'
import FacultySide from '../components/FacultySide'
import speakerIcon from '../images/event/speaker.png'
import CongressModal from '../components/CongressModal'
import CommitteeModal from '../components/CommitteeModal'

const Page = styled.div`
  overflow: hidden;
  .content {
    ${config.layout.auditoriumVid}
    position: absolute;
    background: black;

    iframe {
      height: 100%;
      width: 100%;
    }
  }
  .chat {
    max-width: 350px;
    position: fixed;
    padding-top: ${SIZES.navHeight};
    top: 0;
    left: 67%;
    bottom: 0;
    right: 5%;
    z-index: 30;
  }
  /* .committee-wrap {
    position: fixed;
    top: 100%;
    width: 100%;
    display: flex;
    justify-content: space-evenly;
    .speaker-icon {
      background: #002060;
      border-radius: 48px;
      display: flex;
      align-items: center;
      border: 1px solid white;
      justify-content: center;
      text-decoration: none;
      color: ${COLORS.hotButtonText};
      padding: 5px 16px;
      margin-bottom: 12px;
      margin-top: 12px;
      width: 90%;
      img.speaker {
        border-radius: 0%;
        box-shadow: none;
        transform: scale(1);
      }
    }  
    small {
      font-weight: 800;
      padding: 5px;
      font-size: 70%;
    }
  } */
  .attendance {
    position: fixed;
    bottom: 15%;
    left: 18%;
    width: 48%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    .checkin-icon {
      background: #002060;
      border-radius: 48px;
      display: flex;
      align-items: center;
      border: 1px solid white;
      justify-content: center;
      text-decoration: none;
      color: ${COLORS.hotButtonText};
      padding: 6px 16px;
      margin-bottom: 12px;
      min-width: 150px;
      img.speaker {
        border-radius: 0%;
        box-shadow: none;
        margin-right: 6px;
      }
      small {
        font-weight: 800;
        padding: 3px 0;
        font-size: 70%;
      }
    }
    .action-label {
      color: white;
      font-weight: 500;
      margin: 0 16px;
      font-style: italic;
      align-self: center;
    }
    button {
      background: transparent;
      border: none;
      padding: 0;
      img {
        border-radius: 50%;
      }
    }
    &:hover {
      .action-label,
      img {
        transition: 500ms;
        transform: scale(1.2);
      }
      img {
        box-shadow: 0px 0px 30px 6px #ffad2c;
      }
    }
  }
  .actions {
    position: fixed;
    top: 72%;
    bottom: 23%;
    left: 27%;
    right: 42%;
    display: flex;
    justify-content: space-between;
    button {
      width: 150px;
      background-image: linear-gradient(#492777, #c4000c);
      border: 2px solid #e20613;
      border-radius: 16px;
      color: white;
      font-style: italic;
      font-weight: bold;
      font-size: 12px;
      letter-spacing: 1px;
      &:hover {
        box-shadow: 0px 10px 10px -10px #e20613;
        animation-name: bounce;
        animation-duration: 1s;
        animation-fill-mode: both;
      }
    }
  }
  #mc-logo {
    width: 15%;
    position: fixed;
    top: 33%;
    bottom: 40%;
    left: 2%;
  }
`

export default function AuditoriumPage({
  liveUrl,
  hallNumber,
  currentUser,
}) {
  const [loading, setLoading] = useState(true)
  const [sidebar, setSidebar] = useState(false)
  const [facultySide, setFacultySide] = useState(false)
  const [congressModal, setCongressModal] = useState(false)
  const [committeeModal, setCommitteeModal] = useState(false)

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(muteMusic())

    return () => {
      if (localStorage.getItem('muted') === 'false') {
        dispatch(unmuteMusic())
      }
    }
  }, [dispatch])

  useEffect(() => {
    document.title = `${config.eventName} | Conference`
  }, [])

  useEffect(() => {
    Amplitude.visit(`Auditorium`)
  }, [currentUser.id, hallNumber])

  const toggleFacultySide = () => {
    if (facultySide === false) {
      Amplitude.clickFaculty()
    }
    setFacultySide(!facultySide)
  }
  const toggleSidebar = () => {
    if (sidebar === false) {
      Amplitude.clickCheckIn()
    }
    setSidebar(!sidebar)
  }

  const toggleCongress = () => {
    if (congressModal === false) {
      Amplitude.clickCongress()
    }
    setCongressModal(!congressModal)
  }

  const toggleCommittee =() => {
    if (committeeModal === false) {
      Amplitude.clickCommittee()
    }
    setCommitteeModal(!committeeModal)
  }

  
  return (
    <>
      {loading && <LoadIcon />}
      <Page style={{opacity: loading ? 0 : 1}}>
        <SideAgenda open={sidebar} toggleSidebar={toggleSidebar} hallNumber={hallNumber} currentUser={currentUser} />
        <FacultySide open={facultySide} toggleSidebar={toggleFacultySide} />
        <CongressModal showCongress={congressModal} setShowCongress={toggleCongress} />
        <CommitteeModal showCommittee={committeeModal} setShowCommittee={toggleCommittee} />
        <PageWithBg bgImg={config.assets.auditorium1.landscape}>
          <div className="content">
            <iframe
              title="Live Broadcast"
              src={liveUrl}
              allow="autoplay; fullscreen"
              allowFullScreen
              frameBorder="0"
              onLoad={() => {
                setLoading(false)
              }}
            />
          </div>
          <div className="chat h-100">
            <ChatSection
              currentUser={currentUser}
              firebaseDb={ChatKfairDb}
              hallName={'MainAuditorium'}
            />
          </div>
          {hallNumber === 1 ? (
            <div className="attendance">
              <button className="checkin-icon" onClick={toggleSidebar}>
                <svg width="24" height="24" viewBox="0 0 24 24">
                  <path d="M0,0H24V24H0Z" fill="none"/>
                  <path d="M19,3H14.82A2.988,2.988,0,0,0,9.18,3H5A2.006,2.006,0,0,0,3,5V19a2.006,2.006,0,0,0,2,2H19a2.006,2.006,0,0,0,2-2V5A2.006,2.006,0,0,0,19,3ZM12,3a1,1,0,1,1-1,1A1,1,0,0,1,12,3ZM9.29,16.29,6.7,13.7a1,1,0,0,1,1.41-1.41L10,14.17l5.88-5.88A1,1,0,1,1,17.29,9.7L10.7,16.29a1,1,0,0,1-1.41,0Z" fill={COLORS.hotButtonText} />
                </svg>
                <small>Programme</small>
              </button>
              <button type="button" className="checkin-icon" onClick={toggleFacultySide} >
                <img src={speakerIcon} className="speaker" width="20" alt="icon"/>
                <small>Faculty</small>
              </button>
              <button type="button" className="checkin-icon" onClick={toggleCongress} >
                <img src={speakerIcon} className="speaker" width="20" alt="icon"/>
                <small>Presidents of Congress</small>
              </button>
              <button type="button" className="checkin-icon" onClick={toggleCommittee} >
                <small>Organising Committee + International Advisory Board</small>
              </button>
            </div>  
          ) : (
            <>
              <div className="attendance">
                <button onClick={toggleSidebar}>
                  <img src={attendance} width="60" alt="attendance" />
                </button>
                <small className="action-label">Check-in</small>
              </div>
              <div className="actions">
                {/* <button onClick={displayAgenda}>Agenda</button> */}
                {/* <button onClick={displayFaculty}>Speakers</button> */}
              </div>
              <div id="mc-logo">
                <img src={mcLogo} width="100%" alt="EMC logo" />
              </div>
            </>
          )}
        </PageWithBg>
      </Page>
    </>
  )
}
